import { render, staticRenderFns } from "./BlackHoleUnlockButton.vue?vue&type=template&id=dea0422a&scoped=true"
import script from "./BlackHoleUnlockButton.vue?vue&type=script&lang=js"
export * from "./BlackHoleUnlockButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea0422a",
  null
  
)

export default component.exports